import { useEffect, useState } from "react";
import useCheckPermission from "./useCheckPermission";

const useCheckPermissionHook = ({ code, write }) => {
  const [allow, setAllow] = useState();
  const [loading, setLoading] = useState();
  const { checkReadPermission, checkWritePermission } = useCheckPermission();
  useEffect(() => {
    async function check() {
      if (write) {
        const result = await checkWritePermission(code);
        setAllow(result);
        setLoading(false);
      } else {
        const result = await checkReadPermission(code);
        setAllow(result);
        setLoading(false);
      }
    }
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { allow, loading };
};

export default useCheckPermissionHook;
